import { useNavigationStore } from '~/stores/navigation'
import { getCurrentTabs, getNavigation } from '~/utils/navigation'

export default defineNuxtRouteMiddleware(async (to) => {
  const path = to.fullPath
  const navigationStore = useNavigationStore()
  const navigation = getNavigation(path)
  const currentTabs = getCurrentTabs(navigation)

  navigationStore.setNavigation(navigation)
  navigationStore.setTabs(currentTabs)
})
